import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";
import {
  HeroBanner,
  InvoiceContent,
} from "~/components/sections";
import {
  Header,
  Footer,
  ProductsModal,
  QuestionModal,
} from "~/components/blocks";
import { Breadcrumb } from "~/components/elements";
import { scrollTo } from "~/utils/tools";
import { useDispatch, useSelector } from "react-redux";
import { Creators as PromoActions } from "~/store/modules/promo/actions";
import promoIsActive from "~/utils/promoIsActive";
import { Creators as AccountActions } from "~/store/modules/account/actions";

export default function PromoReg() {
  const history = useHistory();
  const [openModalQuestion, setOpenModalQuestion] = useState(null);
  const [modalData, setModalData] = useState({});
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.authentication?.auth);

  useEffect(() => {
    scrollTo(700);

    if (!promoIsActive()) {
      history.push({pathname: "/minha-conta"});
    }

    if (!userData.user.cadastroCompleto)
      history.push({pathname: "/cadastre-se/passo-1/dados-pessoais"});

    dispatch(PromoActions.getGift());
  }, [history, dispatch, userData]);


  const [products, setProducts] = useState([]);

  const removeProduct = (i) => {
    const newListProduct = products.filter((data, index) => index !== i);
    setProducts(newListProduct);
  };

  const personalData = useSelector((state) => state.account.details.dadosPessoais);
  useEffect(() => {
    dispatch(AccountActions.getUserDetails());
  },[dispatch]);

  useEffect(() => {
    if (personalData.cupons?.length >= 20) {
      history.push({pathname: "/cadastro-promo/sucesso"});
    }
  }, [history, personalData]);

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Minha conta",
      link: "/minha-conta",
    },
    {
      text: "Registrar Compra",
      link: "/cadastro-promo",
    },
  ];

  const handleModalProduct = (data) => {
    setModalData(data);
  };

  const addProduct = (product) => {
    if (!product) return;

    const isEditingProduct = products.find((data) => data.Produto.id === product.Produto.id);

    if (!isEditingProduct) {
      setProducts([...products, product]);
      return;
    }
    const temp = products;
    temp.splice(product.key, 1, product);
    setProducts(temp);
  };

  const handleModalQuestion = (data) => {
    setOpenModalQuestion(data);
  };

  return (
    <>
      <Helmet>
        <title>Participe da promoção | Bebê Johnson's</title>
      </Helmet>
      <Header />
      <ProductsModal
        handleModalProduct={handleModalProduct}
        addProduct={addProduct}
        modalData={modalData}
      />
      <QuestionModal
        questionName={openModalQuestion}
        handleModalQuestion={handleModalQuestion}
      />
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <HeroBanner />
        <Breadcrumb navBreadcrumb={navBreadcrumb} />
        <InvoiceContent
          step={2}
          openModalProduct={handleModalProduct}
          openModalQuestion={handleModalQuestion}
          removeProduct={removeProduct}
          products={products}
        />
      </motion.div>
      <Footer />
    </>
  );
}
